<div class="calculator" *ngIf="show">
    <div class="calculator__header">
        <button class="close-btn" (click)="close()">X</button>
    </div>
    <div class="calculator__body">
        <div class="calculator__input">{{ calculation }}</div>
        <div class="calculator__buttons">
            <button *ngFor="let button of buttons" (click)="onButtonClick(button)">{{ button }}</button>
        </div>
    </div>
</div>
<div class="calculator__button" (click)="toggle()">
    <i class="fa fa-calculator"></i>
</div>